<template>
  <div class="uploader-container ui-p-4 c-bg-white"    @drop.prevent="handleFileDropped" 
        @dragover.prevent>
    <label
      :for="id"
      class="
        ui-p-6 ui-w-full ui-border ui-rounded-md ui-border-dashed
        c-border-gray-300
      "
    >
      <div>
        <img
          no-default-spinner
          class=" ui-m-auto"
          v-if="localImageUrl"
          :class="wide?'wide-image':'square-image'"
          :src="localImageUrl | getImage('400')"
          :placeholder-src="localImageUrl | getImage('10')"
        />
        <div
          class="c-bg-gray-100 ui-m-auto"
          :class="wide?'wide-image':'square-image'"
          v-else
        >
          <div class="ui-h-full ui-flex ui-items-center">
            <image-symbol class="ui-w-20 ui-m-auto" />
          </div>
        </div>

        <div class="c-text-input c-w-full ui-pt-8">
          Arraste e solte a imagem aqui ou
          <c-link class="ui-p-0">selecione o arquivo</c-link>
          do seu computador
        </div>
        <div class="c-text-label c-text-gray ui-pt-2">
          Formato aceito: JPG
        </div>
      </div>
      <input
        class="ui-hidden"
        type="file"
        :id="id"
        accept="image/jpg, image/jpeg"
        @input="handleFileChange"
     
        :error="(!bucketInfo && inputWasFocussed) || wrongFileType"
        :error-message="
          wrongFileType
            ? 'Este campo só suporta imagens com extensão .jpg'
            : 'Este campo é obrigatório'
        "
        @focusin.stop="setInputFocus"
      />
    </label>
  </div>
</template>

<script>
import ImageSymbol from "../components/ImageSymbol.vue";
import { CLink } from "@estrategiahq/coruja-web-ui";

export default {
  components: {
    ImageSymbol,
    CLink,
  },
  data() {
    return {
      file: null,
      bucketInfo: null,
      inputWasFocussed: false,
      wrongFileType: false,
    };
  },
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    id:{
      type: String,
      required: true,
    },
    wide: Boolean,
  },
  computed: {
    localImageUrl() {
      return this.imageUrl;
    },
  },
  filters: {
    getImage(url, size) {
      return url.replace("raw", size);
    },
  },
  methods: {
    setInputFocus() {
      this.inputWasFocussed = true;
    },
    async getPresignedURL() {
      let result = await this.$s.presigned.getPresignedImageURL();
      this.bucketInfo = result;
    },
    async uploadFileToS3() {
      let result = await this.$s.presigned.uploadFile(
        this.bucketInfo.url,
        this.file,
        "image"
      );
      return result;
    },
    async handleFile(file) {
      this.wrongFileType = file?.type !== "image/jpeg";
      if (!this.wrongFileType) {
        this.file = file;
        const tempUrl = URL.createObjectURL(this.file);
        await this.getPresignedURL();
        await this.uploadFileToS3();

        const info = {
          bucketInfo: this.bucketInfo,
          tempUrl,
        };

        this.$emit("file-uploaded", info);
      } else {
        this.$emit("image-upload-error","Este campo só suporta imagens com extensão .jpeg");
      }
    },
    async handleFileChange(event) {
      await this.handleFile(event?.target?.files[0])
    },
    async handleFileDropped(event) {
      await this.handleFile(event?.dataTransfer?.files[0])
    },
  },
};
</script>

<style scoped>
.shadow {
  box-shadow: 0px 0px 10px 0px #dedede;
}
.wide-image {
    height: 148px;
  width: 398px;
}
.square-image {
    height: 148px;
    width: 148px;
}

.placeholder {
  display: block;
  height: 170px;
  width: 170px;
  background-image: url("data:image/png;base64,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");
  margin-bottom: 20px;
}

.uploader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
